import type { UTMParams } from '../types';
import { log } from './logger';

const SESSION_KEY = '__pt_sid';

function newSid(): string {
  return 'sid_' + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

/** Get or create a session ID (persisted in sessionStorage) */
export function getSessionId(): string {
  try {
    let sid = sessionStorage.getItem(SESSION_KEY);
    if (!sid) {
      sid = newSid();
      sessionStorage.setItem(SESSION_KEY, sid);
    }
    return sid;
  } catch (e) {
    log('warn', 'sessionStorage unavailable, using ephemeral sid', e);
    return newSid();
  }
}

/** Collect UTM parameters from current URL */
export function collectUTM(): UTMParams {
  let params: URLSearchParams;
  try {
    params = new URLSearchParams(location.search);
  } catch (e) {
    log('warn', 'cannot parse location.search', e);
    return { source: '', medium: '', campaign: '', term: '', content: '' };
  }
  return {
    source: params.get('utm_source') || '',
    medium: params.get('utm_medium') || '',
    campaign: params.get('utm_campaign') || '',
    term: params.get('utm_term') || '',
    content: params.get('utm_content') || '',
  };
}

/** Get device type from user agent */
export function getDevice(): string {
  return /Mobile|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'pc';
}

/** Simple deterministic hash for deduplication */
export function hashSimple(obj: unknown): string {
  const s = JSON.stringify(obj);
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = ((h << 5) - h + s.charCodeAt(i)) | 0;
  }
  return 'h' + Math.abs(h).toString(36);
}
